import useCache from "../../hooks/use-cache";
import '../../resources/css/news-blog.css';
import { useGetNewsQuery } from '../../store';
import Separator from '../shared/Separator';
import PostBlog from "./posts/PostBlog";

export default function NewsBlog({data}) {

    const cacheKey1 = `news-all-0`;
    const posts = useCache(cacheKey1, useGetNewsQuery, { id: 'all', pageIdentifier: 0 });

    if (!posts?.data?.length) { return; }

    const renderedPosts = posts.data.slice(0, 3).map(p => {
        return <PostBlog key={p.id} post={p}></PostBlog>;
    });

    return (
        <div className="news-blog">
            <div className="news-blog-header">
                <div className="title-h1">{data.content.title}</div>
                <Separator className="color-purple"></Separator>
            </div>
            <div className="news-blog-body">{renderedPosts}</div>
        </div>
    );
}